/**
 * QuickNav - ヘッダーからのクイックナビゲーション
 *
 * Homeアイコンをタップすると、Home画面へ遷移する。
 */

import { Home } from 'lucide-react'
import { useNavigate } from 'react-router'

export const QuickNav = () => {
  const navigate = useNavigate()

  return <Home size={28} onClick={() => navigate('/')} className="shrink-0 cursor-pointer" />
}
